import styled from 'styled-components';
import { Row } from 'antd';
import { AppMenu } from '../../../atoms';

export const StyledRow = styled(Row)`
    align-items: center;
    margin-left: 32px;
`;

export const StyledAppMenu = styled(AppMenu)`
    margin-bottom: 32px;

    .ant-menu-item {
        flex: 1;
        text-align: center;
    }
`;
